var Money = /** @class */ (function () {
    function Money(props) {
        Object.assign(this, props);
        if (props.disabled_at) {
            this.disabled_at = new Date(props.disabled_at);
        }
    }
    return Money;
}());
export default Money;
export var TypeMoney = {
    Primary: 'primary',
    Web: 'web',
    secondary: 'secondary'
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Moneys/Money.ts
// module id = 743
// module chunks = 0